import { render, staticRenderFns } from "./CourseInstitute.vue?vue&type=template&id=1dd01ab6&scoped=true&"
import script from "./CourseInstitute.vue?vue&type=script&lang=js&"
export * from "./CourseInstitute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd01ab6",
  null
  
)

export default component.exports